module.exports = __webpack_public_path__ + "static/media/logo.168ee55d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/logo.svg
// module id = 374
// module chunks = 0